/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientUpdate
 */
export interface ClientUpdate {
    /**
     *
     * @type {string}
     * @memberof ClientUpdate
     */
    name?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof ClientUpdate
     */
    active?: boolean | null;
    /**
     * SIREN - French company identifier (9 digits)
     * @type {string}
     * @memberof ClientUpdate
     */
    siren?: string | null;
}

/**
 * Check if a given object implements the ClientUpdate interface.
 */
export function instanceOfClientUpdate(value: object): value is ClientUpdate {
    return true;
}

export function ClientUpdateFromJSON(json: any): ClientUpdate {
    return ClientUpdateFromJSONTyped(json, false);
}

export function ClientUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientUpdate {
    if (json == null) {
        return json;
    }
    return {

        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'] == null ? undefined : json['active'],
        'siren': json['siren'] == null ? undefined : json['siren'],
    };
}

export function ClientUpdateToJSON(json: any): ClientUpdate {
    return ClientUpdateToJSONTyped(json, false);
}

export function ClientUpdateToJSONTyped(value?: ClientUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'name': value['name'],
        'active': value['active'],
        'siren': value['siren'],
    };
}

